export function formatBytes(bytes: number, decimals = 2): string {
	if (bytes === 0) return '0 Bytes';

	const base = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const sizeIndex = Math.floor(Math.log(bytes) / Math.log(base));

	return (bytes / Math.pow(base, sizeIndex)).toFixed(dm) + ' ' + sizes[sizeIndex];
}
